const axios = require("axios");
var token = localStorage.getItem("Token");
import common from './common'
import request from './request.js'
// 行为埋点api--用户行为推送
export async function behaviorlogPushApi(type) {
  if (!token) {
    token = localStorage.getItem("Token");
  }
    let opType = getOperateType(type);
     // 1、发送post请求-------
    await axios({
        url: "UserBehavior/BehaviorPush?operateType="+opType, //1、请求地址
        method: "post", //2、请求方法
        responseType: "application/json; charset=utf-8",
        headers: {
            Accept: "application/json; charset=utf-8",
            Token:token
        },
      })
        .then(resp => {
            console.log(resp,'resp')
      });
}
//行为类型获取
function getOperateType(type) {
    switch (type) {
        //出口报关-查询
        case 0:
            return "ExportCustomsOrderSearch";
        case 1:
        //出口报关-切换状态栏查询报关列表
            return "ExportCustomsStatusScreenWwitch";
        case 2:
        //出口报关--下载海关回执文件
            return "ExportCustomsEntryFileSingleDownload";
        case 3:
        //出口报关-批量发送委托
            return "ExportCustomsBatchSend";
        case 4:
        //出口报关-刷新列表
            return "ExportCustomsIconRefresh";
        case 5:
        //出口报关-复制报关单号
            return "ExportCustomsEntryCopy";
        case 6:
        //出口报关-复制委托单号
            return "ExportCustomsOrderNoCopy";
        case 7:
        //出口报关-复制提运单号
            return "ExportCustomsBillNoCopy";
        case 8:
        //出口报关-复制客户业务编号
            return "ExportCustomsSeqNoCopy";
        case 9:
        //出口报关-查看委托状态
            return "ExportCustomsOrderStatusSearch";
        case 10:
        //出口报关-查看报关状态
            return "ExportCustomsEntryStatusSearch";
        case 11:
        //出口报关-重置查询条件
            return "ExportCustomsSearchConditionReset";
        case 12:
        //取消前端埋点
        //出口报关-批量下载海关文件
            return "ExportCustomsEntryFileBatchDownload"
        case 13:
        //出口报关-筛选单证类型
            return "OrderFileTypeScreen"
        case 14:
        //出口报关-检索单证号
            return "OrderFileOrderNoSearch"
        case 15:
        //出口报关-预览单个文件
            return "OrderFileSinglePreview"
        case 16:
            //查看自定义通知配置
            return "OrderNoticeCustomNodeConfigSearch"
    }
}

//单点公用登出
// export function  SsoLoginOutApi() {
//       axios({
//         url: "UserLogin/SSOInit", //1、请求地址
//         method: "get", // 2、请求方法
//         responseType: "application/json; charset=utf-8",
//         headers: {
//           Accept: "application/json; charset=utf-8",
//         },
//         params: {
//           urlType: "ssoLogout",
//           token: ""
//         }
//       })
//         // 2、回调函数
//         .then(resp => {
//           var redirectUrl = resp.data.DomainObj;
//             if (resp.data.ResponseCode === 200 && redirectUrl) {
//             window.location.href = redirectUrl;
//           }
//         }).catch(err => {
//           console.log(err, 'errr')
//         });
// }

export function  SsoLoginApi(e) {
      axios({
        url: "UserLogin/SSOInit", //1、请求地址
        method: "get", // 2、请求方法
        responseType: "application/json; charset=utf-8",
        headers: {
          Accept: "application/json; charset=utf-8",
        },
        params: {
          urlType: e.urlType,
          token: e.token
        }
      })
        // 2、回调函数
        .then(resp => {
          var redirectUrl = resp.data.DomainObj;
            window.location.href = redirectUrl;

        }).catch(err => {
          console.log(err,'errr')
        });
}


export async function getUserLoginByTokenApi(token) {
  try {
    const res = await request.post('Sso/UserLogin', {
      'ssoLoginToken': token
    });
    if (res.data.ResponseCode == 200 && res.data.DomainObj) {
      const data = res.data.DomainObj;
      //如果存在客户端账号 直接登录
      if (data.BasicInfo.HasExistClientAccount) {
        const userInfo = { ...data.TokenInfo, ...data.UserInfo }
        console.log(userInfo, 'userInfo')
        common.setUserInfoCache(userInfo)
        window.location.href = userInfo.DefaultPage
      }
      //跳转绑定界面
      else {
        console.log('跳转绑定界面')
        window.location.href = '/#/User/Bind?token='+token
      }
    }
    else {
      console.log('11111')
      common.clearCache();
      window.location.href = '/#/LoginError?txt='+res.data.Message
    }
    console.log('res', res)
  } catch (error) {
    console.log(error);
    common.clearCache();
    window.location.href = '/#/LoginError?txt='+res.data.Message
  }
}



// NetflowUserLoginCallbackUrl
export function   getSsoUrl(e) {
            request.get('Sso/GetSsoUrl', {
                params: {
                    SsoUrlType: e.ssoUrlType,
                    CallbackUrl: e.callbackUrl
                }
            }).then(res => {
        if (res.data.ResponseCode == 200 && res.data.DomainObj) {
          window.location.href = res.data.DomainObj;
          common.SetSsoType(1) //设置为1 代表不需要验证App里的单点逻辑
          console.log(res, '地址')
        }
        else {
          this.$alert(res.data.Message, '异常', {
            confirmButtonText: '确定',
            callback: action => {
              console.log('回调')
            }
            });
          }
          console.log('res', res)
          })
}

export function getSingleLogin() {
  
     getSsoUrl({ ssoUrlType: 'NetflowUserLoginCallbackUrl', callbackUrl: window.location.href});
}



// WEBPACK FOOTER //
// ./src/utils/commonApi.js